


































import Vue from 'vue';

export default Vue.extend({
  name: 'CritterBasicSelect',
  props: {
    search: {
      type: Object,
    },
  },
  data() {
    return {
      languages: [
        'name-CNzh',
        'name-EUen',
        'name-EUde',
        'name-EUes',
        'name-EUfr',
        'name-EUit',
        'name-EUnl',
        'name-EUru',
        'name-JPja',
        'name-KRko',
        'name-TWzh',
        'name-USen',
        'name-USes',
        'name-USfr',
      ],
      hemispheres: ['northern', 'southern'],
    };
  },
  computed: {
    langVal(): string {
      return this.search.lang.text;
    },
    hemiVal(): string {
      return this.search.hemi;
    },
    langObj(): { value: string; text: string }[] {
      const obj: { value: string; text: string }[] = [];
      this.languages.forEach(name =>
        obj.push({
          value: name,
          text: `${name.slice(5, 7)}-${name.slice(-2)}`,
        }),
      );
      return obj;
    },
  },
  methods: {
    updateLang(e) {
      const updatedValue = {
        lang: {
          value: e,
          text: `${e.slice(5, 7)}-${e.slice(-2)}`,
        },
      };
      this.$emit('search', { ...this.search, ...updatedValue });
    },
    updateHemi(e) {
      const updatedValue = {
        hemi: e,
      };
      this.$emit('search', { ...this.search, ...updatedValue });
    },
  },
});
